// Деньги хранятся и ходят по API в копейках (целое). UI показывает рубли.
// Разделитель разрядов — узкий неразрывный пробел из ru-локали (табличный вид).

export type Kopecks = number

const rublesFormat = new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 2 })

// `₽ 1 200 000` — знак впереди (макет STIT), копейки показываем только ненулевые.
export function formatKopecks(kopecks: Kopecks): string {
  return `₽ ${rublesFormat.format(kopecks / 100)}`
}

// Без символа валюты — для инпутов и мест, где ₽ рисуется отдельно.
export function formatRubles(kopecks: Kopecks): string {
  return rublesFormat.format(kopecks / 100)
}

// Разбор пользовательского ввода рублей → копейки. Пусто/мусор → null
// (money-input сам решает, ошибка это или незавершённый ввод).
export function parseRubles(input: string): Kopecks | null {
  const normalized = input.replace(/\s/g, '').replace(',', '.')
  if (normalized === '' || normalized === '.') return null
  const rubles = Number(normalized)
  if (!Number.isFinite(rubles) || rubles < 0) return null
  return Math.round(rubles * 100)
}
